import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    backgroundColor: theme.palette.background.paper,
    padding: '16px',
    borderRadius: '4px',
  },
  scope: {},
  period: {},
  stripeRestrictionId: {},
  price: {},
  orderNumber: {},
}));
